import { truncate } from 'lodash'
import React, { memo, useEffect, useState } from 'react'
import { Bar } from 'react-chartjs-2'

function TopProductChart({ data }) {
  const [labels, setLabels] = useState()
  const [value, setValue] = useState()

  useEffect(() => {
    if (data?.length > 0) {
      const listLabels = data?.map((element) => element.pName)
      const listValue = data?.map((element) => element.pQuantity)
      setValue(listValue)
      setLabels(listLabels)
    }
  }, [JSON.stringify(data)])

  return (
    <div>
      <Bar
        options={{
          indexAxis: 'y',
          elements: {
            bar: {
              borderWidth: 2,
            },
          },
          responsive: true,
          maintainAspectRatio: false,
          plugins: {
            legend: {
              position: 'right',
              display: false,
            },
            tooltip: {
              callbacks: {
                title: (context) => labels[context[0].dataIndex],
              },
            },
          },
          scales: {
            y: {
              ticks: {
                callback(v) {
                  const maxLength = window.innerWidth < 768 ? 15 : 20;
                  return truncate(this.getLabelForValue(v), {
                    length: maxLength,
                    omission: '...',
                  })
                },
                font: {
                  size: window.innerWidth < 768 ? 10 : 12
                }
              },
            },
            x: {
              ticks: {
                stepSize: 1,
                font: {
                  size: window.innerWidth < 768 ? 10 : 12
                }
              },
            },
          },
        }}
        data={{
          labels,
          datasets: [
            {
              label: 'TOTAL VALUE',
              data: value,
              borderColor: ['#5DC6C6', '#FFD166', '#FFAE5C', '#FF7894'],
              backgroundColor: ['#6CCBCB', '#FFDC88', '#FFBC79', '#FF91A9'],
            },
          ],
        }}
        height={window.innerWidth < 768 ? 200 : 300}
      />
    </div>
  )
}

export default memo(TopProductChart)
